import { useContext } from 'react';
import styled from 'styled-components';
import withCollapse from 'enhancers/withCollapse';
import { InterfaceContext } from 'contexts/InterfaceContext';
import Box from 'elements/Box';
import keyboardConstants from 'constants/keyboard';

const { layouts: { COMPACT_LAYOUT }} = keyboardConstants;

const Row = styled(Box)(({ theme }) => `
  display: flex;
  grid-gap: 0.25rem;
`);
const Key = styled(Box)(({ theme, secondary }) => `
  flex: 1;
  display: flex;
  align-items: center;
  line-height: 1.75rem;
  flex-direction: column;
  padding: 0.75rem 0.5rem;
  cursor: pointer;
  color: ${theme.colors.dark};
  background: ${theme.colors.utility.ghost};
  border-radius: ${theme.fontSizes.body};
  border-bottom: ${theme.strokes.thick} solid ${theme.colors.utility.secondary};
  ${secondary ? `
    background: ${theme.colors.utility.ultralight};
  ` : ''}
`);

const Container = withCollapse(styled(Box)(({ theme }) => `
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  grid-gap: 0.25rem;
  padding: 0.75rem;
  border-radius: ${theme.fontSizes.body};
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  background: ${theme.colors.utility.light};
  user-select: none;
  overflow: hidden;
`));

const Keyboard = () => {
  const { isKeyboardVisible, handleKeyDown } = useContext(InterfaceContext);

  return (
    <Container collapse={!isKeyboardVisible}>
      {COMPACT_LAYOUT.map((row, i) => (
        <Row key={i}>
          {row.map((key, j) => (
            <Key
              key={j}
              onClick={() => handleKeyDown({ key: key.initial.key })}
              secondary={!key.initial.alphanumeric}
            >
              {key.initial.display}
            </Key>
          ))}
        </Row>
      ))}
    </Container>
  )
}

export default Keyboard;
